import {
  ADD_ACCESS_PROFILE_FAILURE,
  ADD_ACCESS_PROFILE_LOADING,
  ADD_ACCESS_PROFILE_SUCCESS,
  DELETE_ACCESS_PROFILE_FAILURE,
  DELETE_ACCESS_PROFILE_LOADING,
  DELETE_ACCESS_PROFILE_SUCCESS,
  FETCH_ACCESS_PROFILE_FAILURE,
  FETCH_ACCESS_PROFILE_LOADING,
  FETCH_ACCESS_PROFILE_SUCCESS,
  FETCH_GROUP_ACCESS_FAILURE,
  FETCH_GROUP_ACCESS_SUCCESS,
  UPDATE_ACCESS_PROFILE_FAILURE,
  UPDATE_ACCESS_PROFILE_LOADING,
  UPDATE_ACCESS_PROFILE_SUCCESS,
  ADD_GROUP_WITH_PRIORITY_FAILURE,
  ADD_GROUP_WITH_PRIORITY_LOADING,
  ADD_GROUP_WITH_PRIORITY_SUCCESS,
  UPDATE_GROUP_ZONE_PRIORITIES_SUCCESS,
  UPDATE_GROUP_ZONE_PRIORITIES_FAILURE,
  UPDATE_GROUP_ZONE_PRIORITIES_LOADING,
  FETCH_GROUPS_BY_ZONE_PRIORITY_SUCCESS,
  FETCH_GROUPS_BY_ZONE_PRIORITY_FAILURE,
  FETCH_GROUPS_BY_ZONE_PRIORITY_LOADING,
  CLEAR_GROUP_ACCESS,
  CLEAR_FILTERED_PRIORITY_ACCESS
} from '../Types/accessProfileTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {},
  groupAccess: [],
  zonePriorities: [],
  filteredGroups: []
};

const accessProfileReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_ACCESS_PROFILE_LOADING:
    case ADD_ACCESS_PROFILE_LOADING:
    case UPDATE_ACCESS_PROFILE_LOADING:
    case FETCH_GROUPS_BY_ZONE_PRIORITY_LOADING:
    case UPDATE_GROUP_ZONE_PRIORITIES_LOADING:
    case ADD_GROUP_WITH_PRIORITY_LOADING:
    case DELETE_ACCESS_PROFILE_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_ACCESS_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };
    case ADD_ACCESS_PROFILE_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: null,
        success: 'WFH profile added successfully'
      };
    case CLEAR_GROUP_ACCESS:
      return {
        ...state,
        groupAccess: []
      };
    case ADD_GROUP_WITH_PRIORITY_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload.group],
        zonePriorities: [...state.zonePriorities, ...action.payload.zonePriorities],
        loading: false,
        error: null,
        success: 'Group with priority added successfully'
      };

    case UPDATE_ACCESS_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'profile updated successfully'
      };

    case UPDATE_GROUP_ZONE_PRIORITIES_SUCCESS:
      return {
        ...state,
        zonePriorities: action.payload,
        loading: false,
        error: null,
        success: 'Zone priorities updated successfully'
      };
    case FETCH_GROUPS_BY_ZONE_PRIORITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        filteredGroups: action.payload,
        success: 'Groups fetched successfully'
      };

    case DELETE_ACCESS_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'WFH profile removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };
    case CLEAR_FILTERED_PRIORITY_ACCESS:
      return {
        ...state,
        filteredGroups: [],
        loading: false,
        error: null
      };

    case FETCH_ACCESS_PROFILE_FAILURE:
    case ADD_ACCESS_PROFILE_FAILURE:
    case UPDATE_GROUP_ZONE_PRIORITIES_FAILURE:
    case UPDATE_ACCESS_PROFILE_FAILURE:
    case DELETE_ACCESS_PROFILE_FAILURE:
    case FETCH_GROUPS_BY_ZONE_PRIORITY_FAILURE:
    case ADD_GROUP_WITH_PRIORITY_FAILURE:
    case FETCH_GROUP_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    case FETCH_GROUP_ACCESS_SUCCESS:
      return {
        ...state,
        groupAccess: action.payload,
        loading: false
      };

    default:
      return { ...state };
  }
};

export default accessProfileReducer;
